import { render, staticRenderFns } from "./SaleOrdersNew.vue?vue&type=template&id=01911498&scoped=true"
import script from "./SaleOrdersNew.vue?vue&type=script&lang=js"
export * from "./SaleOrdersNew.vue?vue&type=script&lang=js"
import style0 from "./SaleOrdersNew.vue?vue&type=style&index=0&id=01911498&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01911498",
  null
  
)

export default component.exports